
var LazyImage =  (function(){
	function LazyImage(){
		let register 	= this.register;
		let rect 		= this.isOnRect;
		let lazyimages 	= document.querySelectorAll('lazyimage');

		let style = document.createElement('style');

		style.innerText = '.lazyimage{'+
			'position: relative;'+
			'background: #eee;'+
			'margin-bottom:0'+
		'}'+
		'.lazyimage.loaded{'+
			'background: none'+
		'}'+
		'.lazyimage.loaded .loader{'+
			'display: none'+
		'}'+
		'.lazy-canvas{'+
			'position: absolute;'+
			'width: 100%;'+
			'height:100%;'+
			'left:0;'+
			'top:0;'+
			'overflow: hidden'+
		'}'+
		'.lazyimage .loader{'+
			'position: absolute;'+
			'left: 50%;'+
			'top: 50%;'+
			'transform: translate(-50%, -50%)'+
		'}';

		document.head.appendChild(style);

		if(lazyimages.length > 0){
			for(let i=0;i<lazyimages.length; i++){

				register(lazyimages[i], rect)

			}
		}
	}

	LazyImage.prototype.register = function(el, rect){
		let attributes = {
			src 	: el.getAttribute('src'),
			alt 	: el.getAttribute('alt') 		|| '',
			width 	: el.getAttribute('width') 		|| 0,
			height 	: el.getAttribute('height') 	|| 0,
		}
		
		let scale 	= (attributes.height / attributes.width) * 100;
		let parent 	= el.parentNode;

		let dados = {
			attributes 	: attributes,
			scale 		: scale,
			parent 		: parent,
			loaded 		: false
		}

		let lazyimage = document.createElement('figure');

		lazyimage.dados = dados;

		let style = `width: ${attributes.width}px; max-width: 100%;`;

		lazyimage.setAttribute('style', style);

		let tpl = `<div class="lazy-container" style="padding-bottom:${scale}%;">
			<div class="lazy-canvas">
				<img src="assets/images/loading.gif" class="loader" alt="loading"/>
			</div>
		</div>`;

		lazyimage.insertAdjacentHTML('afterbegin', tpl);

		lazyimage.setAttribute('class', 'lazyimage');

		parent.insertBefore(lazyimage, el);
		parent.removeChild(el);

		rect(lazyimage);

		let jaRect = false;

		window.addEventListener('scroll', function(){
			if(jaRect) return;

			setTimeout(function(){
				jaRect = false;
			}, 100);

			rect(lazyimage);
		});
	}

	LazyImage.prototype.isOnRect = function(el){

		if(!el.dados.loaded){
			if(el.getBoundingClientRect().top < (window.innerHeight + 200)){
				let canvas = el.querySelector('.lazy-canvas');
				let loader = el.querySelector('.loader');

				let img = document.createElement('img');

				for(let attribute in el.dados.attributes){
					img[attribute] = el.dados.attributes[attribute];
				}

				img.setAttribute('class', 'img-fluid');

				canvas.appendChild(img)

				img.addEventListener('load', function(){
					$(this).siblings('.loader').remove()
				});

				el.classList.add('loaded');
				el.dados.loaded = true;
			}
		}
	}

	return LazyImage;
})();

var LazyImages = new LazyImage();

$.fn.lazyimage = function(){
	let jaLazyimage = false;

	function isLazyOnRect (elemento, dados){
		if(!elemento.loaded){
			
			if(elemento.getBoundingClientRect().top <= (window.innerHeight + 200)){
				$(elemento).find('.loader').remove();

				let img = `<img src="${dados.src}" alt="${dados.alt}" width="${dados.width}" height="${dados.height}" class="img-fluid">`;

				$(elemento).find('.fig-canvas').append(img);

				elemento.loaded = true;
			}

		}
	}

	return this.each(function(index, el){
		let width 	= $(this).attr('width');
		let height 	= $(this).attr('height');
		let alt 	= $(this).attr('alt');
		let src 	= $(this).attr('src');

		let scale 	= (height / width) * 100;

		$(this).css({
			'width' 	: width,
			'max-width' : '100%'
		});

		let template = `<div class="fig-container" style="padding-bottom:${scale}%">
			<div class="fig-canvas"><img src="assets/images/loading.gif" class="loader" alt="loading"/></div>
		</div>`;

		$(this).append(template);

		isLazyOnRect(el, {
			src		: src,
			alt 	: alt,
			width 	: width,
			height 	: height
		});

		$(window).scroll(function(){
			if(jaLazyimage) return;

			setTimeout(function(){
				jaLazyimage = false;
			}, 100);

			isLazyOnRect(el, {
				src		: src,
				alt 	: alt,
				width 	: width,
				height 	: height
			});
		});
	});
}

$('lazyimage').lazyimage();